module.exports = __webpack_public_path__ + "img/media-hub-active.0e139841.svg";